import React, { forwardRef } from 'react';

import { TableWrap, TableData, TableHead, HeadColumn } from './TableStyle';
import { GenericDiv } from 'commonStyles';
import ContentTypes from '../ContentSection/ContentTypes';

const Table = ({ tableData = {}, forwardedRef }) => {
	const { styles: tableStyles = {}, header, rows } = tableData;

	const renderDesc = (row, styles = {}) => row.length > 0 && row.map((r) =>
		<TableData {...styles} key={Math.random()}>
			<ContentTypes data={`<span style='word-break: break-word;'>${r}</span>`} />
		</TableData>);

	return (
		<GenericDiv top_M='8' $width='100%' {...tableStyles} bdr={tableStyles.border}>
			<TableWrap layout={tableStyles.layout} ref={forwardedRef} cellPadding='0' cellSpacing='0'>
				<TableHead>
					<tr>
						{header?.data.map((data, index) => (
							<HeadColumn {...header?.styles} key={Math.random()}>
								<ContentTypes data={`<span style='word-break: break-word;'>${data}</span>`} />
							</HeadColumn>

						))}
					</tr>
				</TableHead>
				<tbody>
					{rows?.data.map((data, index) => (
						<tr key={Math.random()}>
							{renderDesc(data, rows?.styles)}
						</tr>
					))}
				</tbody>
			</TableWrap>
		</GenericDiv>
	);
};

export default forwardRef((props, ref) => <Table {...props} forwardedRef={ref} />);
